@let texts = resourcesService.languageFile.value();
@let themeId = store.themeId();
@let themeName = resourcesService.themeById(themeId)?.name;
<div id="score-container">
  <div id="inner-score-container">

    <div id="inner-inner-score-container">
      <h1 class="header" #scoreHeader tabindex="-1">
        @if (themeName) {
          <span>{{ texts.scoreHeaderIfHasTheme }}{{ themeName }}</span>
        } @else {
          <span>{{ texts.scoreHeader }}</span>
        }
      </h1>

      <div class="score-icon-container">
        <img class="score-icon" [src]="scoreIconSource" alt="" aria-hidden="true">
      </div>

      <div class="points">
        <span class="visually-hidden" role="status" [attr.aria-label]="showScore ? accessibleScoreStatus() : null"></span> <!-- //NOSONAR -->
        <div class="points-text" [class.hidden]="!showScore" aria-hidden="true"> {{ store.score() }} {{ texts.points }}</div>
        <div class="points-bar-container" aria-hidden="true">
          <gis-score-bar [showEarnedPointsLabel]="false" [showIcon]="false" [standalone]="false"/>
        </div>
      </div>

      <div class="verdict">
        <div class="verdict-header">
          {{ store.scoreVerdict() }}
        </div>
        <div class="verdict-description">{{ texts.shareOrPlayAgain }}</div>
      </div>

      <div class="buttons">
        <div class="play-again-button">
          <p-button (onClick)="store.stopGame()" [outlined]="true">{{ texts.playAgain }}</p-button>
        </div>
        <gis-share-score/>
      </div>

      <div class="questions-container">
        <h2 class="questions-header">{{ texts.attemptsPerQuestion }}</h2>
        <div class="questions">

          @for (question of store.currentGameQuestions(); track question; let index = $index) {
            <gis-question-answer-card [question]="question" [questionState]="store.finishedQuestionStates()[index]"/>
          }

        </div>
      </div>
    </div>
  </div>
</div>
